import React, {useEffect, useState} from "react";

import DatePicker from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import "../../style/datePicker.css"
import {Input} from "@material-tailwind/react";

const DateField = ({className, date, setDate, label}) => {

  const [curDate, setCurDate] = useState(date || new Date());

  useEffect(() => {
    setCurDate(date || new Date())
  }, [date])

  useEffect(() => {
    if (curDate?.month !== undefined) {
      const selectedDate = curDate.year + "-" + curDate.month.toString().padStart(2, '0') + "-" + curDate.day.toString().padStart(2, '0')
      setDate(selectedDate)
    }
  }, [curDate]);

  if (curDate) {
    return (
      <div style={{direction: "rtl"}} className={className}>
        <DatePicker
          calendar={persian}
          className="rmdp-calendar"
          render={<Input
            label={label}
            variant="standard"
            className="w-full"
          />}
          value={curDate || new Date()}
          onChange={setCurDate}
          locale={persian_fa}
          calendarPosition="bottom-right"
        />
      </div>
    );
  }
};

export default DateField;
